module.exports = __webpack_public_path__ + "img/qq_group.9874008e.png";